import axios from '@/plugins/axios'

export default {
  async getOrder ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/pay/order/' + payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
